export const POSTHOG_URL = 'https://eu.i.posthog.com'
export const BOOTSTRAP_DATA_COOKIE_NAME = 'betterplace-posthog-bootstrap-data'
